export default __webpack_public_path__ + "static/compvote-92e21cba0d022c459532fdaf61951b12.jpg";